var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('administration-offers-layout',{attrs:{"title":"Список типов трафика","error-text":"Список типов трафика не загружен","api-method":_vm.getEmployeesTraffics}})
}
var staticRenderFns = []

export { render, staticRenderFns }